import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "d-flex gap-3 mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" }, null, -1)
const _hoisted_6 = { class: "d-flex flex-column gap-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 text-uppercase fw-bold" }, "Club de origen", -1)
const _hoisted_8 = { class: "text-black fw-bolder fs-6 m-0" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-3 mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "w-20px h-20px bg-primary rounded-circle text-white text-center" }, "1"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-6 text-black" }, "Seleccionar club de destino")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-3 my-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "w-20px h-20px bg-primary rounded-circle text-white text-center" }, "2"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-6 text-black" }, "Motivo del traslado")
], -1)
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "ms-3 bi bi-check-circle text-white" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "rounded w-100 w-md-50 w-lg-50",
    onClosed: _ctx.onClosed,
    onOpened: _ctx.onOpened,
    "close-on-click-modal": false,
    top: "1vh",
    "lock-scroll": "",
    "destroy-on-close": "",
    "show-close": false
  }, {
    header: _withCtx(({ close, titleId, titleClass }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", {
          id: titleId,
          class: _normalizeClass([titleClass, "fw-bolder fs-2 m-0"])
        }, _toDisplayString(_ctx.titleDialog), 11, _hoisted_2),
        _createVNode(_component_el_button, {
          text: "",
          circle: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: "bi bi-x-lg fs-1",
              onClick: close
            }, null, 8, _hoisted_3)
          ]),
          _: 2
        }, 1024)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_button, {
          text: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isModalVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('Cerrar'))
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          color: 'var(--bs-blue2)',
          class: "text-white"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('Confirmar traslado') + " "),
            _hoisted_13
          ]),
          _: 1
        }, 8, ["color"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_avatar, {
          size: 60,
          src: "https://empty"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.itemInstitution?.name), 1),
          (_ctx.itemInstitution?.country?.flag)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "w-30px rounded",
                src: `${_ctx.REPO}/${_ctx.itemInstitution?.country?.flag}`,
                alt: _ctx.itemInstitution?.country?.name 
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        ref: "ruleFormRef",
        model: _ctx.form,
        "status-icon": "",
        rules: _ctx.rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _createVNode(_component_el_select, {
            modelValue: _ctx.form.idinstitution,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.idinstitution) = $event)),
            filterable: "",
            remote: "",
            "reserve-keyword": "",
            clearable: "",
            placeholder: "Ingrese un texto a buscar...",
            "remote-show-suffix": "",
            "remote-method": _ctx.remoteMethod,
            loading: _ctx.loadingRemote,
            "value-key": "idinstitution",
            class: "w-100 mb-4",
            size: "large"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInstitution, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.idinstitution,
                  label: item.name,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "remote-method", "loading"]),
          _hoisted_11,
          _createVNode(_component_el_form_item, {
            prop: "motivo",
            rules: [{ required: true, message: 'Campo requerido', trigger: ['blur', 'change'] }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.motivo,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.motivo) = $event)),
                type: "textarea",
                rows: 4,
                placeholder: "Escriba detalladamente el motivo del traslado aquí..."
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])), [
        [_directive_loading, _ctx.loadingForm]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed", "onOpened"]))
}